import type { TypeBadgeCellRendererProps } from '@thefarmersfront/kitchen';

type TypeBadgeColorMap<TKey extends string> = TypeBadgeCellRendererProps<TKey>['colorMap'];
type TypeBadgeColor<TKey extends string> = NonNullable<TypeBadgeColorMap<TKey>[TKey]>['color'];

/** 코드별 라벨·색 상수로 kitchen BadgeCellRenderer 의 colorMap 을 만든다. */
const createBadgeColorMap = <TKey extends string>(
  labels: Record<TKey, string>,
  colors: Partial<Record<TKey, TypeBadgeColor<TKey>>>
): TypeBadgeColorMap<TKey> =>
  (Object.keys(labels) as TKey[]).reduce<TypeBadgeColorMap<TKey>>(
    (colorMap, key) => ({ ...colorMap, [key]: { label: labels[key], color: colors[key] } }),
    {}
  );

export default createBadgeColorMap;
